import React from 'react';
import type { Wine } from '../types';
import TrashIcon from './icons/TrashIcon';
import EditIcon from './icons/EditIcon';
import ToggleSwitch from './ToggleSwitch';

interface WineListTableProps {
    wineList: Wine[];
    onRemoveWine: (id: number) => void;
    onStartEdit: (wine: Wine) => void;
    onToggleVisibility: (id: number) => void;
}

const WineListTable: React.FC<WineListTableProps> = ({ wineList, onRemoveWine, onStartEdit, onToggleVisibility }) => {
    console.log('WineListTable レンダリング:', { wineListLength: wineList.length, onRemoveWine: typeof onRemoveWine });
    
    if (wineList.length === 0) {
        return <p className="text-center py-4 text-sm sm:text-base" style={{ color: 'var(--theme-text-secondary, #6B7280)' }}>現在、ワインは登録されていません。</p>;
    }

    return (
        <div className="overflow-x-auto relative shadow-md sm:rounded-lg max-h-96">
            <table className="w-full text-xs sm:text-sm text-left" style={{ color: 'var(--theme-text-secondary, #6B7280)' }}>
                <thead className="text-xs uppercase sticky top-0" style={{ backgroundColor: 'var(--theme-bg-secondary, #F3F4F6)', color: 'var(--theme-text-primary, #374151)' }}>
                    <tr>
                        <th scope="col" className="py-2 sm:py-3 px-3 sm:px-6">ワイン</th>
                        <th scope="col" className="py-2 sm:py-3 px-3 sm:px-6">タイプ</th>
                        <th scope="col" className="py-2 sm:py-3 px-3 sm:px-6">産地</th>
                        <th scope="col" className="py-2 sm:py-3 px-3 sm:px-6">品種</th>
                        <th scope="col" className="py-2 sm:py-3 px-3 sm:px-6">価格</th>
                        <th scope="col" className="py-2 sm:py-3 px-3 sm:px-6 text-right">アクション</th>
                    </tr>
                </thead>
                <tbody className="divide-y">
                    {wineList.map((wine) => {
                        console.log('ワイン行レンダリング:', { id: wine.id, name: wine.name });
                        return (
                        <tr key={wine.id} className={`bg-white hover:bg-gray-50 transition-opacity ${!wine.visible ? 'opacity-50' : ''}`}>
                            <th scope="row" className="py-3 sm:py-4 px-3 sm:px-6 font-medium whitespace-nowrap" style={{ color: 'var(--theme-text-primary, #111827)' }}>
                                <div className="flex items-center space-x-2 sm:space-x-3">
                                    <div className="flex-shrink-0">
                                        {wine.image ? (
                                           <img className="h-10 w-10 sm:h-12 sm:w-12 object-contain rounded-md bg-gray-100" src={wine.image} alt={wine.name} />
                                        ) : (
                                           <div className="h-10 w-10 sm:h-12 sm:w-12 bg-gray-100 rounded-md flex items-center justify-center text-gray-400 text-xs text-center p-1">画像なし</div>
                                        )}
                                    </div>
                                    <span className="text-xs sm:text-sm">{wine.name}</span>
                                </div>
                            </th>
                            <td className="py-3 sm:py-4 px-3 sm:px-6 text-xs sm:text-sm">{wine.type}</td>
                            <td className="py-3 sm:py-4 px-3 sm:px-6 text-xs sm:text-sm">{wine.origin}</td>
                            <td className="py-3 sm:py-4 px-3 sm:px-6 text-xs sm:text-sm">{wine.variety}</td>
                            <td className="py-3 sm:py-4 px-3 sm:px-6 text-xs sm:text-sm">¥{typeof wine.price === 'number' ? wine.price.toLocaleString() : '0'}</td>
                            <td className="py-3 sm:py-4 px-3 sm:px-6 text-right">
                                <div className="flex justify-end items-center space-x-1 sm:space-x-2">
                                    <ToggleSwitch
                                        id={`vis-${wine.id}`}
                                        checked={wine.visible}
                                        onChange={() => onToggleVisibility(wine.id)}
                                    />
                                    <button
                                        onClick={() => onStartEdit(wine)}
                                        className="p-1.5 sm:p-2 text-gray-500 hover:text-red-800 hover:bg-red-100 rounded-full transition-colors"
                                        aria-label={`「${wine.name}」を編集`}
                                    >
                                        <EditIcon />
                                    </button>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            
                                            // 即座にアラートを表示してクリックを確認
                                            alert(`🗑️ 削除ボタンがクリックされました！\nワインID: ${wine.id}\nワイン名: ${wine.name}`);
                                            
                                            console.log('=== 削除ボタンクリック ===');
                                            console.log('ワインID:', wine.id);
                                            console.log('ワイン名:', wine.name);
                                            console.log('onRemoveWine関数:', onRemoveWine);
                                            try {
                                                onRemoveWine(wine.id);
                                                console.log('onRemoveWine呼び出し完了');
                                            } catch (error) {
                                                console.error('onRemoveWine呼び出しエラー:', error);
                                            }
                                        }}
                                        className="p-1.5 sm:p-2 text-gray-500 hover:text-red-600 hover:bg-red-100 rounded-full transition-colors"
                                        aria-label={`「${wine.name}」を削除`}
                                    >
                                        <TrashIcon />
                                    </button>
                                </div>
                            </td>
                        </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default WineListTable;